import { useQuery } from "@tanstack/react-query";
import { client, type OoSParcelSchema } from "@augmodo/lebron-browser-client";

export function useFetchParcel(parcelId: string | undefined) {
  return useQuery({
    queryKey: ["parcel", parcelId],
    queryFn: async () => {
      const response = await client.get({
        url: `/v1/oos-parcels/${parcelId}`,
      });

      if (response.error) {
        throw new Error(`Failed to fetch parcel: ${response.error}`);
      }

      return response.data as OoSParcelSchema;
    },
    enabled: !!parcelId,
  });
}
